import { translations } from './storage-progress-bar.i18n'
import { bytesToGB } from '../common/documents.utils'

export function calculatePercentage(current: number, max: number): number {
  if (max <= 0 || current < 0) return 0
  if (current > max) return 100
  return (current / max) * 100
}

/**
 * Must be used with `t` function from internationalization library
 */
export function formatStorageLabelTranslation(current: number, max: number, locale: string = 'pt-BR') {
  const currentGB = bytesToGB(current)
  const maxGB = bytesToGB(max)

  const currentFormatter = new Intl.NumberFormat(locale, {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  })
  const limitFormatter = new Intl.NumberFormat(locale, {
    maximumFractionDigits: 0,
  })

  const formatRelativeValue = (gb: number): string => {
    if (gb < 0.1 && gb > 0) return '< 0.1'
    return currentFormatter.format(gb)
  }

  return translations.storageUsed(formatRelativeValue(currentGB), limitFormatter.format(maxGB))
}
